import React from 'react';
import {RegressionCPU, RegressionGPU} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';
import Value from 'grommet/components/Value';
import Box from 'grommet/components/Box';
import Tiles from 'grommet/components/Tiles';
import NumberInput from 'grommet/components/NumberInput';
import Tile from 'grommet/components/Tile';
import Label from 'grommet/components/Label';

class BubbleSample extends React.Component {
    constructor(props) {
        super(props);

        this.state = { 
            m: null,
            b: null,
            r: null,
            x: 0,
            y: null,
            sse: null,
            showcomponent: false,
            start: false,
            iteration: 0,
            finalObjectAfterSplit: [],
            testObjectAfterSplit: [],
            finalNameFiltered: [],
            learningrate: props.currentElement === "Logistic Gradient Descent CPU" || props.currentElement === "Logistic Gradient Descent" ? 1 : props.currentElement === "Multi Linear Regression" ? 0.0000002 : 0.0003,
            iterations: 100
             }
        this._onChange = this._onChange.bind(this)
        this._onresult = this._onresult.bind(this)
        this._onpredict = this._onpredict.bind(this)
    }
    componentDidMount() {
        
        

        const {dataNames} = this.props;
        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        const length = this.props.dataObject[0].length;
        let finalObjectFiltered = []
        let finalNameFiltered = []
        this.props.dataObject.forEach((input, index) => {
            if (this.props.positionFilter.indexOf(index) > -1) {
                finalObjectFiltered.push(input)
                if (input.length !== length) {console.log("Data sources have different length.")} else  {console.log("Data sources have same length. Good!")}
                finalNameFiltered.push(dataNames[`positionname${index+1}`])
            }
        })

        let finalObjectAfterSplit = []
        let testObjectAfterSplit = []
        let cut;
        if (this.props.dataSplit === "80%-20%") {
            cut = Math.floor(length * 0.8)
        } else if (this.props.dataSplit === "70%-30%") {
            cut = Math.floor(length * 0.7)
        }
        finalObjectFiltered.forEach((ele, index)=>{
            let tempArray1 = []
            let tempArray2= []
            ele.forEach((ele2, index2)=> {
                if (index2 <= cut) {
                    tempArray1.push(ele2)
                } else if (index2 > cut) {
                    tempArray2.push(ele2)
                }
            })
            finalObjectAfterSplit.push(tempArray1)
            testObjectAfterSplit.push(tempArray2)
        })
        this.setState({showcomponent: true, finalObjectAfterSplit, testObjectAfterSplit, finalNameFiltered})   
    }
    _onChange(field, event) {
        const {r2, scatter} = this.state
        switch(field) {
            case "learningrate":
                this.setState({ learningrate: event.target.value})
                break;
            case "iterations":
                this.setState({ iterations: event.target.value })
                break;
            case "r2":
                this.setState({ r2: !r2 })
                break;
            case "scatter":
                this.setState({ scatter: !scatter })
                break;
            
            case "error":
                this.setState({ error: event.target.value })
                break;
            case "predict":
                this.setState({ x: event.target.value})
                break;
        }
    }
    _onresult(event) {
        const {m, b, iteration, sse} = event.detail;
        this.setState({m, b, iteration, sse})
    }
    _onpredict(event) {
        console.log("onpredict")
        //if (event.details.y === NaN) return
        const {y} = event.detail
        this.setState({y})
    }
    _onSaveOutput() {
        const {m,b,iteration,see,finalObjectAfterSplit, testObjectAfterSplit, finalNameFiltered} = this.state;

        localStorage.setItem("finalObjectAfterSplit", finalObjectAfterSplit);
    }
    _onSubmit(e) {
        
        const field1 = "field1"
        const field2 = "field2"
        const field3 = "field3"
        e.preventDefault();
        const url = "https://script.google.com/macros/s/AKfycbzyLBp7nDwdTzU0n4Btr3UkoBZBeYBlpxwL4EpPlsk-mJ7G9k0/exec"
        /* fetch(url)
            .then(function(response) {
                console.log(response)
            }) */
        
        
        
        function postData(url = ``, data = {}) {
                // Default options are marked with *
                  return fetch(url, {
                      method: "GET", // *GET, POST, PUT, DELETE, etc.
                      //mode: "cors", // no-cors, cors, *same-origin
                      //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                      //credentials: "same-origin", // include, *same-origin, omit
                      //headers: {
                      //    "Content-Type": "application/json",
                          // "Content-Type": "application/x-www-form-urlencoded",
                      //},
                      //redirect: "follow", // manual, *follow, error
                      //referrer: "no-referrer", // no-referrer, *client
                      data: data, // body data type must match "Content-Type" header
                      params: data
                  })
                  .then(response => console.log(response)); // parses JSON response into native Javascript objects 
              }
              postData(url, {"field1": "field1"})
              .then(data => console.log(data)) // JSON-string from `response.json()` call
              .catch(error => console.error(error));

              console.log(postData.url)
    }

    render() {
        const {m, b, 
            iteration, 
            sse, x, y, 
            showcomponent, 
            finalObjectAfterSplit, 
            testObjectAfterSplit, 
            finalNameFiltered,
            learningrate,
            iterations
        } = this.state
        //optionsObject = {learningrate, iterations, scatter, equation, error}
        let m2digits, b2digits, y2digits, sse2digits;
        if (m && b && iteration) {
            m2digits = m.toFixed(2)
            b2digits = b.toFixed(2)
            sse2digits = sse.toFixed(2)
            y2digits = y ? y.toFixed(2) : "?"
        } else {
            m2digits = "?"
            b2digits = "?"
            sse2digits = "?"
            y2digits = y ? y.toFixed(2) : "?"
        }
        let component;
        if (this.props.currentElement === "Linear Gradient Descent CPU") {
            component = <RegressionCPU 
                xs={finalObjectAfterSplit[0]} 
                ys={finalObjectAfterSplit[1]} 
                names={finalNameFiltered}
                x={x} 
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations} />
        } else if (this.props.currentElement === "Logistic Gradient Descent CPU") {
            component = <RegressionCPU 
                xs={finalObjectAfterSplit[0]} 
                ys={finalObjectAfterSplit[1]}
                names={finalNameFiltered}
                x={x} 
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations}
                type={"logistic"} />
        } else if (this.props.currentElement === "Linear Gradient Descent") {
            component = <RegressionGPU 
                xs={finalObjectAfterSplit[0]} 
                ys={finalObjectAfterSplit[1]}
                names={finalNameFiltered}
                x={x} 
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations} 
                predictdata={testObjectAfterSplit}/>
        } else if (this.props.currentElement === "Logistic Gradient Descent") {
            component = <RegressionGPU 
                xs={finalObjectAfterSplit[0]} 
                ys={finalObjectAfterSplit[1]}
                names={finalNameFiltered}
                x={x} 
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations} 
                type={"logistic"}
                predictdata={testObjectAfterSplit} />
        }
        const value = this.props.currentElement === "Logistic Gradient Descent" ||  this.props.currentElement === "Logistic Gradient Descent CPU"
        ? `f(x) = 1 / e ^ (-1 * (${m2digits}x + ${b2digits}))`
        : `f(x) = ${m2digits}x + ${b2digits}`
        return (
            <div>
                <Box>
                    {/* <button onClick={this._onSaveOutput.bind(this)}> Save this</button>	 */}  

                    <div style={{top: "10px", right: "0"}}>
                        <Box direction='row'
                                justify='center'
                                align='center'
                                wrap={true}
                                reverse={false}
                                margin='none'>
                                <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                    <Label>
                                    Learning Rate
                                    </Label>
                                    <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                        <NumberInput defaultValue={learningrate} step={0.001} onChange={this._onChange.bind(this, 'learningrate')} />
                                    </Box>
                                </Box>
                                <Box direction='row'    
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'> 
                                    <Label>
                                        Iterations
                                    </Label>
                                    <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'> 
                                        <NumberInput defaultValue={iterations} step={1} onChange={this._onChange.bind(this, 'iterations')} />
                                    </Box>
                                </Box>
                        </Box>
                        
                    </div>

                    <Tiles>
                    <h2 style={{paddingTop: "5px"}}><strong>Results</strong></h2>
                        <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelect}>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                    <Value value={iteration}
                                        label='Iteration'
                                        size='medium'
                                        responsive={true}
                                    />
                                    </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={1} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                        <Value value={value}
                                            label='Equation'
                                            size='medium'
                                            responsive={true}
                                        />
                                        </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={2} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                        <Value value={sse2digits}
                                            label='Error'
                                            size='medium'
                                            responsive={true}
                                        />
                                    </Box>
                                </Box>	
                            </Tile>
                        </Tiles>
                    </Tiles>
                </Box>
                {/* <Box direction='row'    
                    align='center'
                    wrap={true}
                    pad='small'
                    margin='none'> 
                    <Label>
                        {"Predict"}
                    </Label>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'> 
                            <NumberInput 
                                defaultValue={x} 
                                step={1} 
                                onChange={this._onChange.bind(this, 'predict')} />
                    </Box>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        style={{paddingLeft: "50px"}}> 
                             <Value value={y2digits}
                                            label='Prediction'
                                            size='medium'
                                            responsive={true}
                            />
                    </Box>
                </Box> */}
                 {(showcomponent) && component}
            </div>
        );
    }
}

export default BubbleSample;



// WEBPACK FOOTER //
// ./src/samples/run/lrgd.js